import { render, staticRenderFns } from "./orderNxSend-wx.vue?vue&type=template&id=23711064&scoped=true"
import script from "./orderNxSend-wx.vue?vue&type=script&lang=js"
export * from "./orderNxSend-wx.vue?vue&type=script&lang=js"
import style0 from "./orderNxSend-wx.vue?vue&type=style&index=0&id=23711064&prod&scoped=true&lang=css"
import style1 from "./orderNxSend-wx.vue?vue&type=style&index=1&id=23711064&prod&lang=css"
import style2 from "./orderNxSend-wx.vue?vue&type=style&index=2&id=23711064&prod&scoped=true&lang=scss"
import style3 from "./orderNxSend-wx.vue?vue&type=style&index=3&id=23711064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23711064",
  null
  
)

export default component.exports